"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const loading_1 = __importDefault(require("components/cosmos/loading"));
const translate_1 = require("components/translate");
const modulePage_1 = require("./modulePage");
const ModulePageList = ({ t, module, isLoadingPages = false }) => {
    if (isLoadingPages) {
        return (0, jsx_runtime_1.jsx)(loading_1.default, { center: true });
    }
    if (module.pages.length === 0) {
        return ((0, jsx_runtime_1.jsx)("span", { className: "_px-8 _pb-4 _text-gray-500 _text-1 _text-center", children: t('content_list.total_pages_none') }));
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: module.pages.map((page, index) => {
            const isLast = module.pages.length - 1 === index;
            return ((0, jsx_runtime_1.jsx)(modulePage_1.ModulePage, { moduleId: module.id, pageId: page.id, pageName: page.title, pageDescription: page.description, isChecked: page.isChecked, contentType: page.type, published: page.published, isLast: isLast }, page.id));
        }) }));
};
exports.default = (0, translate_1.translate)()(ModulePageList);
